import React, { useRef, useState } from "react";
import theme, { text_colors } from "../../../theme";
import { Avatar, Button, IconButton} from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import FileUpload, { UploadStatus } from "../../../components/molecules/FileUpload";

interface FileStatus {
  file: File;
  status: UploadStatus;
}

export const CommentTextArea = ({ 
  onSave, 
  onUploadFile,
  onRemoveFile
  } : {
  onSave: (value: string) => void, 
  onUploadFile: (blobId: string) => void
  onRemoveFile: (blobId: string) => void
}) => {

  const [textInput, setTextInput] = useState<string>("")
  const inputRef = useRef<HTMLInputElement>(null);
  const [clearFiles, setClearFiles] = useState<boolean>(false)
  const isDisabled = !textInput.trim();
  const [isActive, setIsActive] = useState<boolean>(false)

  const handleClick = () => {
    inputRef.current?.click();
    setClearFiles(false)
  };
  
  return (
    <>
      <div style={{ display: "flex" }}>
        {/* <Avatar src={user?.picture} sx={{ width: 32, height: 32 }} /> */}
        <textarea
          style={{
            width: "100%",
            minHeight: "60px",
            resize: "vertical",
            border: `1px solid ${text_colors.grey}`,
            borderRadius: "3px",
            padding: "8px 12px",
            fontSize: "14px",
            fontFamily: "inherit",
            outline: "none",
          }}
          placeholder={!isActive ? "What’s the hub been up to? Leave a note." : ""}
          onFocus={() => setIsActive(true)}
          onBlur={() => {
            if (!textInput) setIsActive(false);
          }}

          value={textInput}
          onChange={(e) => setTextInput(e.target.value)}
        >
        </textarea>
      </div>
        <FileUpload onRemove={onRemoveFile} onUpload={onUploadFile} inputRef={inputRef} urlCatalog="comments" accept="image/png, image/jpeg" clearFiles={clearFiles}/>
      <div style={{ display: "flex", justifyContent:"space-between", marginTop: "8px" }}>
        <IconButton component="label" onClick={handleClick}>
          <AttachFile/>
        </IconButton>
        <Button 
          disabled={isDisabled} 
          variant={"contained"} 
          size={"small"} 
          onClick={() => {
            setClearFiles(true);
            onSave(textInput)
            setTextInput("")
            setIsActive(false)
          }}>
            Comment
        </Button>
      </div>


    </>

  )
}


